module.exports = __webpack_public_path__ + "img/santa-cruz-25.df8f7049.png";